'use strict';

import type { UserSoaStatus } from '../../Entities/User/UserSoaStatus';
import { EntityCollection } from '../EntityCollection';

export class UserSoaStatusCollection extends EntityCollection<UserSoaStatus> {}
